import { DestroyableObstacle } from "../destroyableObstacle";
import { ParticleType } from "../particleType";
import { deserializeXY } from "../serialization";
import type { XY } from "../xy";

export class PottedPlant extends DestroyableObstacle {
	static key = "PottedPlant";
	constructor(xy: XY) {
		super(xy);
	}

	getDebrisParticleType(): ParticleType {
		return ParticleType.LEAF_DEBRIS;
	}

	static deserialize(data: any): PottedPlant {
		const p = new PottedPlant(deserializeXY(data.xy));
		p.restoreBaseFields(data);
		return p;
	}
}
